function applyGridView(columns) {

  const grid = document.getElementById('product-grid');

  if (!grid) return;

  [...grid.classList].forEach(cls => {

    if (cls.match(/^grid--\d+-col-desktop$/)) {
      grid.classList.remove(cls);
    }

  });

  grid.classList.add(`grid--${columns}-col-desktop`);

  document.querySelectorAll('.grid-btn').forEach(btn => {
    btn.classList.remove('active');
  });

  document
    .querySelector(`.grid-btn[data-columns="${columns}"]`)
    ?.classList.add('active');

  localStorage.setItem('collectionGridColumns', columns);
}

function initSavedGridView() {

  const savedColumns =
    localStorage.getItem('collectionGridColumns') || '3';

  applyGridView(savedColumns);
}

document.addEventListener('DOMContentLoaded', () => {

  initSavedGridView();

  document.addEventListener('click', function(e) {

    const button = e.target.closest('.grid-btn');

    if (!button) return;

    e.preventDefault();

    applyGridView(button.dataset.columns);

  });

});


const observer = new MutationObserver(() => {

  if (document.getElementById('product-grid')) {

    initSavedGridView();

  }

});

observer.observe(document.body, {
  childList: true,
  subtree: true
});

document.addEventListener('DOMContentLoaded', function () {
    const faqItems = document.querySelectorAll('.faq-accordion-item');

    faqItems.forEach((item, index) => {
      const button = item.querySelector('.faq-question');
      const answer = item.querySelector('.faq-answer');

      
      if (index === 0) {
        item.classList.add('active');
        answer.style.display = 'block';
      }

      button.addEventListener('click', () => {
        const isActive = item.classList.contains('active');

        faqItems.forEach((faq) => {
          faq.classList.remove('active');
          faq.querySelector('.faq-answer').style.display = 'none';
        });

        if (!isActive) {
          item.classList.add('active');
          answer.style.display = 'block';
        }
      });
    });
  });

  // pdp related js

  function initRelatedProductsSplide(scope = document) {

  scope.querySelectorAll('product-recommendations').forEach((section) => {

    const splideEl = section.querySelector('.products-available');

    if (!splideEl) return;

    if (splideEl.classList.contains('splide--related-initialized')) return;
const totalSlides = splideEl.querySelectorAll('.splide__slide').length;
    const splide = new Splide(splideEl, {
      type: 'slide',
      perPage: 4,
      gap: '11px',
      arrows: totalSlides > 4,
      pagination: false,
      drag: totalSlides > 4,

      breakpoints: {

        1200: {
          perPage: 3
        },

        990: {
          perPage: 2
        },

        750: {
          perPage: 2,
          padding: {
            right: '0px',
            left: '0px'
          }
        }

      }

    });

    splide.mount();

    splideEl.classList.add('splide--related-initialized');

  });

}


/* AUTO INIT */
function autoInitRelatedProducts(scope = document) {
  initRelatedProductsSplide(scope);
}


/* INITIAL LOAD */
document.addEventListener('DOMContentLoaded', () => {

  autoInitRelatedProducts();

  document.querySelectorAll('product-recommendations').forEach((el) => {

    relatedObserver.observe(el, {
      childList: true,
      subtree: true
    });

  });

});


/* SHOPIFY THEME EDITOR */
document.addEventListener('shopify:section:load', (e) => {
  autoInitRelatedProducts(e.target);
});

document.addEventListener('shopify:section:select', (e) => {
  autoInitRelatedProducts(e.target);
});


/* OBSERVE AJAX LOAD */
const relatedObserver = new MutationObserver(() => {
  autoInitRelatedProducts();
});
